/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import { FC, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {JurisdictionComponentData} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/JurisdictionZone/JurisdictionZoneModule';
import {$UIText} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/UIText';
import {Store} from '@gongxigames/framework/core';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';

const getResponsive = ({fixedPosition}: JurisdictionComponentData) => {
    if (fixedPosition) {
        const boxX = fixedPosition === 'right' ? '100%' : '0';
        const x = fixedPosition === 'right' ? '-20px' : '20px';

        return {
            box: {x: boxX},
            translate: {x, y: '20px'}
        } as ResponsiveConf;
    }
};

export const $JurisdictionZoneText: FC<JurisdictionComponentData> = (props) => {
    return <$UIText
        stylePreset={props.stylePreset}
        responsive={getResponsive(props)}
        text={props.text}
        localeID={props.localeId}
        values = {Store.computed(() => {
            return {
                value: getProp(props.value)
            };
        })}
    />;
};